"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dangerSignQuestionOrder = void 0;
exports.getDangerSignQuestionOrder = getDangerSignQuestionOrder;
/**
 * Danger sign questions as concept codes, in the order of the "newborn w danger signs" and
 * "child w danger signs" tabs. A parent (vomiting, disposition) comes before the question it opens.
 */
exports.dangerSignQuestionOrder = {
    newborn: ['convulsions', 'chest_indrawing', 'latching', 'disposition', 'wakefulness'],
    child: ['seizure', 'drinking', 'latching', 'vomiting', 'vomits_everything', 'disposition', 'wakefulness'],
};
/**
 * Get the danger sign question order for a patient type, empty for tracks without one.
 */
function getDangerSignQuestionOrder(patientType) {
    return exports.dangerSignQuestionOrder[patientType] ?? [];
}
